import { render, staticRenderFns } from "./setUp.vue?vue&type=template&id=3d8216a7"
import script from "./setUp.vue?vue&type=script&lang=js"
export * from "./setUp.vue?vue&type=script&lang=js"
import style0 from "./setUp.vue?vue&type=style&index=0&id=3d8216a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports